/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Impact_MattersInputs */

const en_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impact Matters`)
};

const es_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El impacto importa`)
};

const de_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Impact zählt`)
};

const zh_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`击球至关重要`)
};

const ar_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لحظة الضرب مهمة`)
};

const fr_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’impact compte`)
};

const vi_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cú tiếp xúc quyết định`)
};

const sw_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mgongano ni muhimu`)
};

const th_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จังหวะปะทะสำคัญ`)
};

const bs_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impact je presudan`)
};

const ja_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インパクトの瞬間が大切`)
};

const ko_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임팩트가 중요하다`)
};

const pt_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O impacto importa`)
};

const it_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'impatto conta`)
};

const sv_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impact räknas`)
};

const nl_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impact`)
};

const da_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Påvirkningsforhold`)
};

const nb_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impact teller`)
};

const fi_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaikutukset`)
};

const pl_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impakt ma znaczenie`)
};

const ru_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вопросы воздействия`)
};

const tr_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etki Önemlidir`)
};

const hi_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रभाव मामले`)
};

const id_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impact penting`)
};

const ms_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hentaman Itu Penting`)
};

const cs_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Záležitosti dopadu`)
};

const el_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η στιγμή του impact μετράει`)
};

const he_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הרגע של האימפקט חשוב`)
};

const af_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impak tel`)
};

const hu_home_impact_matters = /** @type {(inputs: Home_Impact_MattersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A találat pillanata számít`)
};

/**
* | output |
* | --- |
* | "Impact Matters" |
*
* @param {Home_Impact_MattersInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_impact_matters = /** @type {((inputs?: Home_Impact_MattersInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Impact_MattersInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_impact_matters(inputs)
	if (locale === "de") return de_home_impact_matters(inputs)
	if (locale === "zh") return zh_home_impact_matters(inputs)
	if (locale === "ar") return ar_home_impact_matters(inputs)
	if (locale === "fr") return fr_home_impact_matters(inputs)
	if (locale === "vi") return vi_home_impact_matters(inputs)
	if (locale === "sw") return sw_home_impact_matters(inputs)
	if (locale === "th") return th_home_impact_matters(inputs)
	if (locale === "bs") return bs_home_impact_matters(inputs)
	if (locale === "ja") return ja_home_impact_matters(inputs)
	if (locale === "ko") return ko_home_impact_matters(inputs)
	if (locale === "pt") return pt_home_impact_matters(inputs)
	if (locale === "it") return it_home_impact_matters(inputs)
	if (locale === "sv") return sv_home_impact_matters(inputs)
	if (locale === "nl") return nl_home_impact_matters(inputs)
	if (locale === "da") return da_home_impact_matters(inputs)
	if (locale === "nb") return nb_home_impact_matters(inputs)
	if (locale === "fi") return fi_home_impact_matters(inputs)
	if (locale === "pl") return pl_home_impact_matters(inputs)
	if (locale === "ru") return ru_home_impact_matters(inputs)
	if (locale === "tr") return tr_home_impact_matters(inputs)
	if (locale === "hi") return hi_home_impact_matters(inputs)
	if (locale === "id") return id_home_impact_matters(inputs)
	if (locale === "ms") return ms_home_impact_matters(inputs)
	if (locale === "cs") return cs_home_impact_matters(inputs)
	if (locale === "el") return el_home_impact_matters(inputs)
	if (locale === "he") return he_home_impact_matters(inputs)
	if (locale === "af") return af_home_impact_matters(inputs)
	if (locale === "hu") return hu_home_impact_matters(inputs)
	return en_home_impact_matters(inputs)
});